export default __webpack_public_path__ + "static/media/crime.68bcc299.png";